// Client-side hint list. Used purely to show/hide the "anyone with @domain
// can join" notice in CreateWorkspaceModal. The server enforces the full
// blocklist (workspace_allowed_domain::validate_workspace_domain).
const COMMON_FREE_DOMAINS = new Set([
  'gmail.com', 'googlemail.com',
  'outlook.com', 'hotmail.com', 'live.com', 'msn.com',
  'yahoo.com', 'yahoo.co.uk', 'icloud.com', 'me.com',
  'proton.me', 'protonmail.com', 'pm.me',
  'aol.com', 'gmx.com', 'mail.com', 'fastmail.com', 'hey.com',
  'duck.com',
])

export function isFreeEmailDomain(domain: string): boolean {
  return COMMON_FREE_DOMAINS.has(domain.toLowerCase())
}
